import LockIcon from '@mui/icons-material/Lock';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BlueButton } from '../../../atoms/BlueButton';
import { CHECKOUT_URLS } from '../../../config';
import { isMobile } from '../../../utils';
import { useMe } from '../../../config/api/queries';

export type CtaState = 'both' | 'mineral' | 'vitamin';

type BloodCta = {
  title: string;
  description: string;
  label: string;
  link: string;
};

const ctaStates: Record<CtaState, BloodCta> = {
  mineral: {
    title: 'UNLOCK BLOOD MINERAL RESULTS',
    description:
      'YOUR FULL BLOOD REPORT IS MISSING THE BLOOD MINERAL TEST. THE ROOTINE BLOOD MINERAL TEST ANALYZES MAGNESIUM, COPPER, ZINC, SELENIUM, CADMIUM, AND MERCURY. GUIDES DOSING FOR MAGNESIUM, COPPER, ZINC, SELENIUM, VITAMIN C, AND VITAMIN E. GET RESULTS IN 5 DAYS.',
    label: 'Get Blood Mineral Test',
    link: CHECKOUT_URLS.blood_mineral_test.link,
  },
  vitamin: {
    title: 'UNLOCK BLOOD VITAMIN RESULTS',
    description:
      'YOUR FULL BLOOD REPORT IS MISSING THE BLOOD VITAMIN TEST. THE ROOTINE BLOOD VITAMIN TEST ANALYZES VITAMIN B6, VITAMIN D3, VITAMIN B9, VITAMIN B12, HOMOCYSTEINE, AND HIGH-SENSITIVITY CRP. GET RESULTS IN 5 DAYS.',
    label: 'Get Blood Vitamin Test',
    link: CHECKOUT_URLS.blood_test.link,
  },
  both: {
    title: 'UNLOCK MORE BLOOD RESULTS',
    description:
      'YOUR FULL BLOOD REPORT IS MISSING THE BLOOD VITAMIN & BLOOD MINERAL TEST. THE ROOTINE BLOOD VITAMIN TEST ANALYZES VITAMIN B6, VITAMIN D3, VITAMIN B9, VITAMIN B12, HOMOCYSTEINE, AND HIGH-SENSITIVITY CRP. THE ROOTINE BLOOD MINERAL TEST ANALYZES MAGNESIUM, COPPER, ZINC, SELENIUM, CADMIUM, AND MERCURY. GET RESULTS IN 5 DAYS.',
    label: 'Get Blood Vitamin & Mineral Test Bundle',
    link: CHECKOUT_URLS.blood_bundle.link,
  },
};

export interface BloodReportCtaProps {
  type: CtaState;
  bgCover?: boolean;
}

export const BloodReportCta = (props: BloodReportCtaProps): JSX.Element => {
  const me = useMe();
  const navigate = useNavigate();
  const cta = ctaStates[props.type];

  const hasLegacyBloodResults = me.data?.blood_result;

  const color = hasLegacyBloodResults ? 'white' : '';

  const bgProps = props.bgCover
    ? {
        height: '100vh',
        backgroundImage: isMobile()
          ? 'url(/images/blood_report_bg_mobile.png)'
          : 'url(/images/blood_report_bg.png)',
        backgroundSize: 'cover',
      }
    : {};

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={bgProps}
    >
      <Grid container item rowSpacing={2} xs={12} sx={{ textAlign: 'center' }}>
        <Grid item xs={12}>
          <Typography fontSize={16} color={color}>
            <LockIcon sx={{ position: 'relative', top: 4 }} />
            {cta.title}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography fontSize={14} color={color}>
            {cta.description}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <BlueButton
            buttonfill="true"
            label={cta.label}
            fontSize={12}
            href={cta.link}
          />
        </Grid>

        {hasLegacyBloodResults && (
          <Grid item xs={12}>
            <Typography
              color={color}
              sx={{
                fontSize: { xs: 12 },
                paddingTop: 2,
                alignSelf: 'center',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/dashboard/blood-results')}
            >
              {'View my old results'}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
